import React from 'react';
import { SplitContext } from './SplitContext';
import { ERROR_UM_NO_USECONTEXT } from './constants';
import { checkHooks } from './utils';
/**
 * 'useManager' is a hook that returns the Manager instance from the Split factory.
 * It uses the 'useContext' hook to access the factory at Split context, which is updated by
 * the SplitFactory component.
 *
 * @return A Split Manager instance, or null if used outside the scope of SplitFactory
 * @see {@link https://help.split.io/hc/en-us/articles/360020448791-JavaScript-SDK#manager}
 */
export function useManager() {
    if (!checkHooks(ERROR_UM_NO_USECONTEXT))
        return null;
    var factory = React.useContext(SplitContext).factory;
    return factory ? factory.manager() : null;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-react/es/useManager.js
// module id = 3957
// module chunks = 25